export const WHATSAPP_PREFIX = "whatsapp:+";
export const SMS_PREFIX = "+";
export const MAX_FILE_SIZE = 52428800;
export const COPY_SUCCESS_MESSAGE = "Mensaje copiado.";
export const CONNECTION_ERROR_MESSAGE = "No hay conexión a Internet.";
export const NOTIFICATION_TIMEOUT = 4000;
export const ERROR_MODAL_MESSAGES = {
  ADD_PARTICIPANT: {
    title: "No se puede agregar al participante",
    description:
      "Se produjo un error al agregar el participante a la conversación",
  },
  CHANGE_CONVERSATION_NAME: {
    title: "No se puede guardar el nombre de la conversación",
    description:
      "Solo los creadores de la conversación pueden editar el nombre de la conversación.",
  },
};
export const CONVERSATION_MESSAGES = {
  CREATED: "Conversación creada.",
  NAME_CHANGED: "Nombre de la conversación cambiado.",
  LEFT: "Has salido de la conversación.",
  MESSAGE_DELETED: "Mensaje eliminado.",
  MESSAGE_DELETE_FAILED: "Error al eliminar el mensaje. Error: ",
  MESSAGE_EDITED: "Mensaje editado.",
  MESSAGE_EDIT_FAILED: "Error al editar el mensaje. Error: ",
};

export const PARTICIPANT_MESSAGES = {
  ADDED: "Participante agregado.",
  REMOVED: "Participante eliminado.",
};

export const USER_PROFILE_MESSAGES = {
  FRIENDLY_NAME_UPDATED: "Nombre amigable del perfil de usuario actualizado.",
};

export const CONVERSATION_PAGE_SIZE = 30;

export const NOTIFICATION_LEVEL = {
  DEFAULT: "default",
  MUTED: "muted",
};

export const MAX_MESSAGE_LINE_WIDTH = 75;
